/**
 * 单据审批流程设置
 *
 * linkPrefix            单据详情前缀 业务审批列表跳转详情页依赖此配置
 * listRouter            列表页路由。详情页送审后，如果当前用户第一关不是审批人，跳回列表页
 * resetAuthCode:        重置（撤回）审批，对应被审批流程控制的按钮权限码。
 * neededApplyCheckFlag: 是否需要送审（0|1），通常草稿发布类的审批均需要先送审，锁定单据编辑状态；该字段以后端设置为准。
 * billType              单别。如果条件组设置了自定义字段，需要配置。
 *
 * 增加审批流程步骤：
 * 1. 在 WORKFLOW_CONFIG 增加配置项。
 * 2. 在单据详情页增加 workflow 对象。
 * 3. 给侧栏组件增加 workflow 属性。
 * 4. 在单据详情页，根据审批状态，增加对按钮的控制。
 *    a. 编辑按钮是否显示: workflow.data?.wfTypeCode?.canEdit
 *    b. 受控按钮是否显示：workflow.data?.wfTypeCode?.complete
 * 5. 列表页增加 workflow 对象。
 * 6. 列表页判断如果开启了审批流程，隐藏受控按钮：item?.workflow?.isPending === false。
 * 7. 列表页如果需要显示审批状态：
 *    <p *ngFor="let wfStatus of item.workflow?.arrStatus">
 *      {{ wfStatus.arrStatusName[0] }}
 *    </p>
 * 8. 送审前校验。在详情页workflow对象中增加校验方法。该方法需要返回布尔值。
 *    applyValidate: () => {
 *      return this.validate();
 *    }
 * 9. 送审后自动跳至列表页， 列表页路由: listRouter
 * 10.  autoPublishFlag: 0, //自动发布
 *      showAutoPublishFlag: true, //是否显示自动发布（前端维护）
 * 11.  autoCheckFlag: 0|1, // 自动送审
 *      showAutoCheckFlag: true, // 是否显示自动送审
 * 12.  lineEditFlag: 0 // 审批中编辑
        showLineEditFlag: true // 是否显示审批中编辑（前端维护）
        lineEditFields: ['remark', 'xxx'] // 审批中编辑字段列表
        lineEditFieldsList: [] // 审批中可编辑字段配置（前端维护）
 */
export const WORKFLOW_CONFIG = {
  '1001': {
    wfmCode: '1001',
    wfmName: 'BASE.SUPPLIER_STATEMENTS', //供应商对账单
    billXkNoField: 'recoXkNo',
    linkPrefix: '/purchase/billing/statement/detail/', // /purchase/billing/statement/detail/5216280761758166?companyCode=91904378
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'reco_pub_0',
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10040102',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BUTTON.OK',
        wfTypeCode: 'reco_cfm_5',
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10040104',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1002': {
    wfmCode: '1002',
    wfmName: 'COST_BILL.SUPPLIER_COST', //供应商费用单
    billXkNoField: 'csoXkNo',
    listRouter: '/purchase/billing/cost/list',
    linkPrefix: '/purchase/billing/cost/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'cost_publish',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10040404',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BUTTON.OK',
        wfTypeCode: 'cost_cfm_4',
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10040404',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1003': {
    wfmCode: '1003',
    wfmName: 'BASE.SUPPLIER_INVOICE', //供应商发票
    billXkNoField: 'invXkNo',
    linkPrefix: '/purchase/billing/invoice/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      { act: 'BUTTON.PUBLISH' },
      {
        act: 'BUTTON.OK',
        wfTypeCode: 'invo_cfm_8',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10040203',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1004': {
    wfmCode: '1004',
    wfmName: 'INQUIRY_TENDER.ITEMS_INQUIRY_TENDER1', //物料询价招标,
    billXkNoField: 'inqXkNo',
    listRouter: '/purchase/inquiry/prod/list',
    linkPrefix: '/purchase/inquiry/prod/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'inqu_publish_2',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10050307',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '延长中' },
      {
        act: '报价中',
        wfTypeCode: 'inq_delay_2',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10050309',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '待比价' },
      {
        act: '比价中',
        wfTypeCode: 'inq_price_compare_4',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10050316',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '结束中' },
      {
        act: '比价中',
        wfTypeCode: 'inq_finish_4',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10050303',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '取消中' },
      {
        act: '已取消',
        wfTypeCode: 'inq_cancel_3',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10050303',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1005': {
    wfmCode: '1005',
    wfmName: 'BASE.POTENTIAL_VENDOR', //'潜在供应商',
    billXkNoField: 'xkUniqueCode',
    listRouter: '/purchase/sourcing/list',
    linkPrefix: '/purchase/sourcing/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      { act: 'BUTTON.APPLY_FOR' },
      {
        act: 'BUTTON.OK',
        wfTypeCode: 'qven_cfm_2',
        resetAuthCode: '10090106',
        showAutoPublishFlag: true,
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BUTTON.CONVERT_TO_OFFICIAL',
        wfTypeCode: 'potVendor_transfer2Vendor_4',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '10090107',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1006': {
    wfmCode: '1006',
    wfmName: 'BASE.OPPORTUNITY_MANAGEMENT', //商机管理
    billXkNoField: 'oppXkNo',
    linkPrefix: '/sale/opportunity-management/lead/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      { act: 'BUTTON.PUBLISH' },
      {
        act: 'BUTTON.PUBLISH_ITEM_LIST',
        wfTypeCode: 'oppo_prod_3',
        resetAuthCode: '20080203',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BUTTON.CONVERT_TO_INQUIRY',
        wfTypeCode: 'oppo_trans_1',
        resetAuthCode: '20080207',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1007': {
    wfmCode: '1007',
    wfmName: 'INQUIRY_TENDER.SUPPLIER_BIDDING', //竞价单
    billXkNoField: 'bidXkNo',
    listRouter: '/purchase/inquiry/bid/list',
    linkPrefix: '/purchase/inquiry/bid/detail/',
    billType: '55',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'bidd_publish_2',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10070305',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '延长中' },
      {
        act: '报价中',
        wfTypeCode: 'bid_delay_2',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10070306',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '取消中' },
      {
        act: '已取消',
        wfTypeCode: 'bid_cancel_3',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10070305',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '比价中' },
      {
        act: 'BUTTON.PUBLISH_RESULTS',
        wfTypeCode: 'bidd_cfm_5',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10070304',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1008': {
    wfmCode: '1008',
    wfmName: 'BASE.IQC_ORDER', //来料检验单
    billXkNoField: 'vfoXkNo',
    linkPrefix: '/purchase/iqc/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'veri_publish_1',
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10080103',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1009': {
    wfmCode: '1009',
    wfmName: 'BASE.8D_REPORT', //8d报告
    billXkNoField: 'p8dXkNo',
    listRouter: '/purchase/iqc/8d-report/list',
    linkPrefix: '/purchase/iqc/8d-report/detail/',
    list: [
      { act: 'WORKFLOW.PURCHASE_NEW' },
      {
        act: 'WORKFLOW.PURCHASE_PUBLISH',
        wfTypeCode: '8D_publish_1',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10080504',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'WORKFLOW.SUPPLIER_PUBLISH',
        wfTypeCode: '8D_vpublish_2',
        resetAuthCode: '20031004',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BASE.AUDIT',
        wfTypeCode: '8D_cfm_4',
        resetAuthCode: '10080506',
        showAutoPublishFlag: true,
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1010': {
    wfmCode: '1010',
    wfmName: 'BASE.LOGISTICS_BIDDING', //物流竞价
    billXkNoField: 'lboXkNo',
    listRouter: '/purchase/inquiry/bid/freightage/list',
    linkPrefix: '/purchase/inquiry/bid/freightage/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'logistics_bid_publish_1',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10070903',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BUTTON.PUBLISH_RESULTS',
        wfTypeCode: 'logistics_bid_cfm_5',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '10070905',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1011': {
    wfmCode: '1011',
    wfmName: 'BASE.ITEM_ACCESS_REPORT', //物料准入报告
    billXkNoField: 'materialReportXkNo',
    linkPrefix: '/purchase/supplier/buyoff-report/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      { act: 'BUTTON.PUBLISH' },
      {
        act: 'BUTTON.AUDIT',
        wfTypeCode: 'material_report_4',
        resetAuthCode: '10051204',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1012': {
    wfmCode: '1012',
    wfmName: 'BASE.PAYMENT_ORDER', //付款单
    billXkNoField: 'rcpXkNo',
    linkPrefix: '/purchase/payment/order/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      { act: 'BUTTON.PUBLISH' },
      {
        act: 'BUTTON.AUDIT',
        wfTypeCode: 'receipt_audit_2',
        resetAuthCode: '10040306',
        showAutoPublishFlag: true,
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1013': {
    wfmCode: '1013',
    wfmName: 'BASE.PO_ORDER', //采购单
    billType: '10',
    billXkNoField: 'poXkNo',
    listRouter: '/purchase/order/list', // /purchase/order/list?companyCode=91904378
    linkPrefix: '/purchase/order/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'purchase_publish_1',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '10010111',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: 'BASE.SUPPLIER_REPLY' },
      {
        act: 'BUTTON.OK',
        wfTypeCode: 'purchase_answer_1',
        resetAuthCode: '10010103',
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BASE.E-SIGN',
        wfTypeCode: 'purchase_esign_1',
        resetAuthCode: '10110102',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1014': {
    wfmCode: '1014',
    wfmName: 'BASE.CHECK_PRICE', //核价单
    billType: '23',
    billXkNoField: 'prcXkNo',
    listRouter: '/purchase/pricing/list',
    linkPrefix: '/purchase/pricing/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      { act: 'BUTTON.PUBLISH' },
      {
        act: 'BUTTON.AUDIT',
        wfTypeCode: 'pricing_audit',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10070803',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1015': {
    wfmCode: '1015',
    wfmName: 'ECN.ECN_REPORT', //PCN通知
    billXkNoField: 'reportXkNo',
    listRouter: '/purchase/ecn/list',
    linkPrefix: '/purchase/ecn/detail/',
    list: [
      {
        act: 'ECN.R&D_AUDIT',
        wfTypeCode: 'ecn_audit_rd',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10051604',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'ECN.SQM_AUDIT',
        wfTypeCode: 'ecn_audit_sqm',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10051604',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'ECN.IQC_AUDIT',
        wfTypeCode: 'ecn_audit_iqc',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10051604',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BUTTON.FINISH',
        wfTypeCode: 'ecn_audit_close',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10051604',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1016': {
    wfmCode: '1016',
    wfmName: 'DELIVERY.DELIVERY_CHANGE_NOTICE', //交料通知单
    billXkNoField: 'acnXkNo',
    listRouter: '/purchase/delivery-change/list',
    linkPrefix: '/purchase/delivery-change/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'advice_note_publish_1',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10010502',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BUTTON.CONFIRM_DIFF',
        wfTypeCode: 'advice_note_answer_3',
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10010506',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1017': {
    wfmCode: '1017',
    wfmName: 'SCHEDULE.SUPPLY_PLAN_SCHEDULE', //供应计划排程
    billXkNoField: 'batchNo',
    listRouter: '/purchase/plan/schedule/list',
    linkPrefix: '/purchase/plan/schedule/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'schedule_publish_1',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10020205',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1018': {
    wfmCode: '1018',
    wfmName: 'BASE.SUPPLIER_ASSESSMENT', //供应商准入评估报告
    billXkNoField: 'admissionReportXkNo',
    linkPrefix: '/purchase/supplier/assessment-report/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      { act: 'BUTTON.APPLY_TO_AUDIT' },
      {
        act: 'BUTTON.AUDIT',
        wfTypeCode: 'admission_report_4',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '10090304',
        showLineEditFlag: true, // 是否显示审批中编辑（前端维护）
        lineEditFieldsList: [
          { id: 'cateAuditStatus', text: 'ACCESS.CATEGORY_AUDIT_STATUS' } // 品类审核状态
        ], // 审批时可编辑字段（前端配置）
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1019': {
    wfmCode: '1019',
    wfmName: 'MALL.INTRO_INTER_MALL', //内部商城引入单
    billXkNoField: 'inductXkNo',
    listRouter: '/purchase/mall/introduce-list',
    linkPrefix: '/purchase/mall/introduce-detail/',
    list: [
      { act: 'BASE.NEW' },
      { act: 'BUTTON.OK' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'introduce_order_1',
        neededApplyCheckFlag: 1,
        showLineEditFlag: true, // 是否显示审批中编辑（前端维护）
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10090402',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1020': {
    wfmCode: '1020',
    wfmName: 'BASE.SUPPLIER_PENALTY_NOTICE', //供应商违约/索赔通知单
    billXkNoField: 'pnhXkNo',
    listRouter: '/purchase/supplier/penalty-notice/list',
    linkPrefix: '/purchase/supplier/penalty-notice/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'punish_notice_publish',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10051802',
        wfXkNo: '',
        wfNodeList: [],
        showAutoPublishFlag: true
      },
      { act: 'BUTTON.RETURN' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'punish_notice_returnPublish',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10051802',
        wfXkNo: '',
        wfNodeList: [],
        showAutoPublishFlag: true
      }
    ]
  },
  '1021': {
    wfmCode: '1021',
    wfmName: 'BASE.SUPPLIER_EXIT_NOTICE', //供应商清退
    billXkNoField: 'elXkNo',
    listRouter: '/purchase/supplier/terminate/list',
    linkPrefix: '/purchase/supplier/terminate/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'eliminate_vendor_publish_1',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10051902',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1022': {
    wfmCode: '1022',
    wfmName: 'BASE.PR', //请购单
    billType: '19',
    billXkNoField: 'reqXkNo',
    listRouter: '/purchase/requisition/list',
    linkPrefix: '/purchase/requisition/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'requisition_publish',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '10010803',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1023': {
    wfmCode: '1023',
    wfmName: 'INQUIRY_TENDER.ITEMS_INQUIRY_TENDER2', //物料询价招标,
    billXkNoField: 'inqXkNo',
    listRouter: '/purchase/inquiry/prod/list',
    linkPrefix: '/purchase/inquiry/prod/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'bid_publish_2',
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        neededApplyCheckFlag: 1,
        resetAuthCode: '10050307',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '延长中' },
      {
        act: '报价中',
        wfTypeCode: 'tender_delay_2',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10050309',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '待比价' },
      {
        act: '比价中',
        wfTypeCode: 'tender_price_compare_4',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10050316',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '结束中' },
      {
        act: '比价中',
        wfTypeCode: 'tender_finish_4',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10050316',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '取消中' },
      {
        act: '已取消',
        wfTypeCode: 'tender_cancel_3',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10050303',
        wfXkNo: '',
        wfNodeList: []
      }
      // { act: 'BUTTON.END_TENDER' },
      // { act: 'BUTTON.FINISH_COMPARE' },
      // {
      //   act: 'BUTTON.PUBLISH_RESULTS',
      //   wfTypeCode: 'bid_cfm_5',
      //   showAutoPublishFlag: true, //是否显示自动发布（前端维护）
      //   resetAuthCode: '10050306',
      //   wfXkNo: '',
      //   wfNodeList: []
      // }
    ]
  },
  '1024': {
    wfmCode: '1024',
    wfmName: 'BASE.PAY_APPLY_SHEET', //付款申请单,
    billXkNoField: 'pmaXkNo',
    listRouter: '/purchase/payment/apply/list',
    linkPrefix: '/purchase/payment/apply/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH'
      },
      {
        act: 'BUTTON.OK',
        wfTypeCode: 'payment_apply_audit',
        resetAuthCode: '10040603',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1026': {
    wfmCode: '1026',
    wfmName: 'BASE.INTERNAL_REQUIREMENT', //询价需求单,
    billXkNoField: 'inqXkNo',
    listRouter: '/purchase/inquiry/inner/list',
    linkPrefix: '/purchase/inquiry/inner/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'inner_inq_publish_2',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10070403',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1027': {
    wfmCode: '1027',
    wfmName: 'BASE.PROJECT_TENDER', //项目招标,
    billXkNoField: 'pbXkNo',
    listRouter: '/purchase/inquiry/project/ifb/list',
    linkPrefix: '/purchase/inquiry/project/ifb/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'INQUIRY.PROJECT_IDENT',
        wfTypeCode: 'project_bidding_publish_0',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10071302',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'project_bidding_publish_1',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10071303',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '延长中' },
      {
        act: '报价中',
        wfTypeCode: 'project_delay_2',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10071313',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '截止中' },
      {
        act: '待评标',
        wfTypeCode: 'project_finish_3',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10071303',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BASE.BID_EVALUATION',
        wfTypeCode: 'project_evaluate_11',
        resetAuthCode: '10071304',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '取消中' },
      {
        act: '已取消',
        wfTypeCode: 'project_cancel_7',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10071318',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: 'INQUIRY.END_BID_EVA' },
      {
        act: 'BUTTON.PUBLISH_RESULTS',
        wfTypeCode: 'project_bidding_publish_2',
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10071306',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '作废中' },
      {
        act: 'BUTTON.ABANDON',
        wfTypeCode: 'project_bidding_abandon',
        resetAuthCode: '10071307',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1028': {
    wfmCode: '1028',
    wfmName: 'BASE.ACCEPTANCE', //采购验收
    billXkNoField: 'accpXkNo',
    linkPrefix: '/purchase/receive/acceptance/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      { act: 'BUTTON.PUBLISH' },
      {
        act: 'BUTTON.AUDIT',
        wfTypeCode: 'accp_audit',
        resetAuthCode: '10031204',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1029': {
    wfmCode: '1029',
    wfmName: 'BASE.MULTI_ITEM_BIDDING', //多物料竞价单
    billXkNoField: 'bidXkNo',
    listRouter: '/purchase/inquiry/bid-multi/list',
    linkPrefix: '/purchase/inquiry/bid-multi/detail/',
    billType: '84',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'bidds_publish_2',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10070602',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '延长中' },
      {
        act: '报价中',
        wfTypeCode: 'bids_delay_2',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10070606',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '取消中' },
      {
        act: '已取消',
        wfTypeCode: 'bids_cancel_3',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10070603',
        wfXkNo: '',
        wfNodeList: []
      },
      { act: '比价中' },
      {
        act: 'BUTTON.PUBLISH_RESULTS',
        wfTypeCode: 'bidds_cfm_5',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10070605',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1030': {
    wfmCode: '1030',
    wfmName: 'BASE.SUPPLIER_INFOR_CHANGE', //供应商信息变更
    billXkNoField: 'ccXkNo',
    listRouter: '/purchase/supplier/info-change/list',
    linkPrefix: '/purchase/supplier/info-change/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      { act: 'BUTTON.PUBLISH' },
      {
        act: 'BUTTON.AUDIT',
        wfTypeCode: 'vInfoChanged_audit',
        resetAuthCode: '10052002',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1031': {
    wfmCode: '1031',
    wfmName: 'BASE.DELAY_DELIVERY_APPLY', //延迟送货申请
    billXkNoField: 'acnXkNo',
    billType: '26',
    listRouter: '/purchase/delivery-delay/list',
    linkPrefix: '/purchase/delivery-delay/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      { act: 'BUTTON.PUBLISH' },
      {
        act: 'BUTTON.OK',
        wfTypeCode: 'delay_delivery_apply',
        showAutoPublishFlag: true,
        resetAuthCode: '10030402',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1032': {
    wfmCode: '1032',
    wfmName: 'BASE.ADVANCE_PAYMENT', //预付款
    billXkNoField: 'ppmXkNo',
    listRouter: '/purchase/payment/advance/list',
    linkPrefix: '/purchase/payment/advance/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'prepayments_publish_1',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '10041003',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BUTTON.CONFIRM',
        wfTypeCode: 'prepayments_cfm_2',
        resetAuthCode: '10041006',
        showAutoPublishFlag: true,
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1033': {
    wfmCode: '1033',
    wfmName: 'BASE.RECEIVED_ORDER', //收货单
    billXkNoField: 'roXkNo',
    listRouter: '/purchase/receive/note/list',
    linkPrefix: '/purchase/receive/note/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'receiveOrder_publish_1',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10030204',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1034': {
    wfmCode: '1034',
    wfmName: 'BASE.DELIVERY_NOTE', //送货单
    billType: '22',
    billXkNoField: 'dnXkNo',
    listRouter: '/purchase/receive/notify/list',
    linkPrefix: '/purchase/receive/notify/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.APPROVE_SHIPPING_REQUEST',
        wfTypeCode: 'delivery_notice_apply',
        neededApplyCheckFlag: 1,
        showAutoCheckFlag: true, // 是否显示自动送审（前端维护）
        showAutoPublishFlag: true,
        resetAuthCode: '10030105',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1035': {
    wfmCode: '1035',
    wfmName: 'BASE.IMPROVE_REPORT', //改善报告
    billXkNoField: 'irXkNo',
    listRouter: '/purchase/supplier/improvement-report/list',
    linkPrefix: '/purchase/supplier/improvement-report/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'improve_report_publish',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10052303',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1036': {
    wfmCode: '1036',
    wfmName: 'BASE.VALUE_SLIP', //核价失效单
    billXkNoField: 'priXkNo',
    listRouter: '/purchase/pricing/invalid/list',
    linkPrefix: '/purchase/pricing/invalid/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'pricing_invalid_publish_2',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10071603',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1037': {
    wfmCode: '1037',
    wfmName: 'BASE.VENDOR_CONTRACT', //供应商合同
    billXkNoField: 'conXkCode',
    linkPrefix: '/purchase/supplier/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'vendor_contract_publish',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10050602',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BUTTON.AUDIT',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        wfTypeCode: 'vendor_contract_audit',
        resetAuthCode: '10110102',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BUTTON.SIGN_CONTRACT',
        wfTypeCode: 'vendor_contract_signed',
        resetAuthCode: '10110102',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  '1038': {
    wfmCode: '1038',
    wfmName: 'BASE.SUPPLIER_REGISTRATION', //供应商登记
    billXkNoField: 'xkUniqueCode',
    listRouter: '/purchase/sourcing/supplier/registration/list',
    linkPrefix: '/purchase/sourcing/supplier/registration/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      { act: 'BUTTON.APPLY_FOR' },
      {
        act: 'BUTTON.AUDIT',
        wfTypeCode: 'apply_register_audit',
        resetAuthCode: '10090202',
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        showAutoCheckFlag: true, // 是否显示自动送审
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1039: {
    wfmCode: '1039',
    wfmName: 'BASE.SAMPLE_NOTICE_ORDER', // 索样通知单
    billXkNoField: 'ncsoXkNo',
    listRouter: '/purchase/order/sample/list',
    linkPrefix: '/purchase/order/sample/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'notice_cable_audit',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '10011203',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1040: {
    wfmCode: '1040',
    wfmName: 'BASE.VENDOR_QUALIFIES', // 供应商资质
    billXkNoField: 'vcXkNo',
    listRouter: '/purchase/supplier/qualification/list',
    linkPrefix: '/purchase/supplier/qualification/detail/',
    list: [
      { act: 'BUTTON.PUBLISH' },
      {
        act: 'BUTTON.OK',
        wfTypeCode: 'vendor_certificates_cfm_2',
        resetAuthCode: '10050704',
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1041: {
    wfmCode: '1041',
    wfmName: 'QUALIFICATION.MATERIAL_QUAL', // 物料资质
    billXkNoField: 'vcXkNo',
    listRouter: '/management/basic-data/qualification/list',
    linkPrefix: '/management/basic-data/qualification/detail/',
    list: [
      { act: 'BUTTON.PUBLISH' },
      {
        act: 'BUTTON.OK',
        wfTypeCode: 'prod_certificates_cfm_2',
        resetAuthCode: '10050704',
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1042: {
    wfmCode: '1042',
    wfmName: 'COMPANY_NOTIFY.VENDOR_NOTIFY', // 供应商通知
    billXkNoField: 'id',
    listRouter: '/purchase/supplier/notice/list',
    linkPrefix: '/notify/detail/2/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.SEND',
        wfTypeCode: 'vendor_notify_publish',
        resetAuthCode: '10050502',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1043: {
    wfmCode: '1043',
    wfmName: 'ECN.MATERIAL_DISCONTINUATION_REPORT', // 物料停产报告
    billXkNoField: 'reportXkNo',
    listRouter: '/purchase/supplier/product-discontinuance-report/list',
    linkPrefix: '/purchase/supplier/product-discontinuance-report/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.AUDIT',
        wfTypeCode: 'stop_product_audit',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10052603',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1044: {
    wfmCode: '1044',
    wfmName: 'BASE.CATEGORY_MANAGE_ORDER', //品类管理单
    billXkNoField: 'pcmXkNo',
    listRouter: '/purchase/supplier/prod-cat/list',
    linkPrefix: '/purchase/supplier/prod-cat/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'pcm_publish_1',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10052703',
        wfXkNo: '',
        showAutoPublishFlag: true,
        wfNodeList: []
      }
    ]
  },
  1045: {
    wfmCode: '1045',
    wfmName: 'BASE.INQUIRY_PRICE_COMPARISON', //询价-比价单
    billXkNoField: 'pcXkNo',
    billType: '51',
    listRouter: '/purchase/inquiry/quote-compare/list',
    linkPrefix: '/purchase/inquiry/quote-compare/detail/',
    list: [
      { act: 'BUTTON.FINISH_COMPARE' },
      {
        act: 'BUTTON.PUBLISH_RESULTS',
        wfTypeCode: 'inqu_cfm_5',
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10050306',
        showLineEditFlag: true, // 是否显示审批中编辑（前端维护）
        lineEditFieldsList: [
          { id: 'remark', text: 'BASE.REMARK_INFO' }, // 备注说明
          { id: 'nextExpectedPrice', text: 'BASE.EXPECTED_PRICE_NEXT_ROUND' } // 下轮期望价格
        ], // 审批时可编辑字段（前端配置）
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1046: {
    wfmCode: '1046',
    wfmName: 'BASE.TENDER_PRICE_COMPARISON', //招标-比价单
    billXkNoField: 'pcXkNo',
    billType: '51',
    listRouter: '/purchase/inquiry/quote-compare/list',
    linkPrefix: '/purchase/inquiry/quote-compare/detail/',
    list: [
      { act: 'BUTTON.FINISH_COMPARE' },
      {
        act: 'BUTTON.PUBLISH_RESULTS',
        wfTypeCode: 'bid_cfm_5',
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10050306',
        showLineEditFlag: true, // 是否显示审批中编辑（前端维护）
        lineEditFieldsList: [
          { id: 'remark', text: 'BASE.REMARK_INFO' }, // 备注说明
          { id: 'nextExpectedPrice', text: 'BASE.EXPECTED_PRICE_NEXT_ROUND' } // 下轮期望价格
        ], // 审批时可编辑字段（前端配置）
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1047: {
    wfmCode: '1047',
    wfmName: 'BASE.DRAW_CHANGE_NOTICE', // 图纸变更通知
    billXkNoField: 'pgcXkNo',
    listRouter: '/purchase/supplier/prod-graph/list',
    linkPrefix: '/purchase/supplier/prod-graph/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'pgc_publish_1',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10052203',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1048: {
    wfmCode: '1048',
    wfmName: 'BASE.PURCHASE_CHANGE', // 采购变更
    billXkNoField: 'pocXkNo',
    listRouter: '/purchase/change/list',
    linkPrefix: '/purchase/change/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'co_publish_0',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10010202',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'BUTTON.OK',
        wfTypeCode: 'co_diffAnswerCfm_1',
        resetAuthCode: '10010202',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1049: {
    wfmCode: '1049',
    wfmName: 'BASE.INQUIRY_QUOTE_NOTE', // 询价-报价单
    billXkNoField: 'quoXkNo',
    linkPrefix: '/purchase/inquiry/prod/quotation/',
    list: [
      { act: 'BASE.RETURNING' },
      {
        act: 'BASE.PUBLIC_RETURN',
        wfTypeCode: 'inq_return_2',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10050304',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1050: {
    wfmCode: '1050',
    wfmName: 'BASE.TENDER_QUOTE_NOTE', // 招标-报价单
    billXkNoField: 'quoXkNo',
    linkPrefix: '/purchase/inquiry/prod/quotation/',
    list: [
      { act: 'BASE.RETURNING' },
      {
        act: 'BASE.PUBLIC_RETURN',
        wfTypeCode: 'tender_return_2',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10050304',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1051: {
    wfmCode: '1051',
    wfmName: 'BASE.PROJECT_TENDER_BID', // 项目招标-投标单
    billXkNoField: 'pbqXkNo',
    linkPrefix: '/purchase/inquiry/project/ifb/bid/detail/',
    list: [
      { act: 'BASE.RETURNING' },
      {
        act: 'BASE.BID_RETURN',
        wfTypeCode: 'project_return_11',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true, //是否显示自动发布（前端维护）
        resetAuthCode: '10071304',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1052: {
    wfmCode: '1052',
    wfmName: 'CUSTOMS.CUSTOMS_DATA_MANAGEMENT', // 关务资料管理
    billXkNoField: 'cpcXkNo',
    linkPrefix: '/management/basic-data/customs/detail/',
    list: [
      {
        act: 'CUSTOMS.PURCHASING_AUDIT', // 采购审核
        wfTypeCode: 'purchase_audit',
        neededApplyCheckFlag: 1,
        resetAuthCode: '30030904',
        wfXkNo: '',
        wfNodeList: []
      },
      {
        act: 'CUSTOMS.CUSTOMS_AUDIT', // 关务审核
        wfTypeCode: 'customs_affairs_audit',
        neededApplyCheckFlag: 1,
        resetAuthCode: '30030905',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1053: {
    wfmCode: '1053',
    wfmName: 'BASE.TOOLING_CHANGE_ORDER', // 工装信息变更单
    billXkNoField: 'tcoXkNo',
    linkPrefix: '/purchase/tooling/change/detail/',
    list: [
      { act: 'BUTTON.PUBLISH' },
      {
        act: 'BUTTON.AUDIT',
        wfTypeCode: 'toolings_change_order_audit',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '10100303',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1054: {
    wfmCode: '1054',
    wfmName: 'BASE.STORAGE_ORDER', // 入库单
    billXkNoField: 'stoXkNo',
    linkPrefix: '/purchase/receive/storage/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'storageOrder_publish_1',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '10030204',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1055: {
    wfmCode: '1055',
    wfmName: 'BASE.SAMPLE_MANAGEMENT', // 样品管理
    billXkNoField: 'stkXkNo',
    linkPrefix: '/purchase/supplier/sample/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BASE.SAMPLE_RESULT_FLAG',
        wfTypeCode: 'sample_track_order_confirm',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '10050804',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1056: {
    wfmCode: '1056',
    wfmName: '采购员绩效评估单', // 采购员绩效评估单
    billXkNoField: 'sheetXkNo',
    linkPrefix: '/statistics/staff/kpi/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'buyer_evaluation_sheet_publish',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '10010704',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1057: {
    wfmCode: '1057',
    wfmName: 'BASE.MATERIAL_APPLY_NOTE', // 物料申请单
    billXkNoField: 'cpaXkNo',
    linkPrefix: '/management/basic-data/prod/apply/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'prod_apply_publish',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '30031102',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1058: {
    wfmCode: '1058',
    wfmName: '委外退料单', // 委外退料单
    billXkNoField: 'ortoXkNo',
    linkPrefix: '/purchase/outsource/material-return/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.SIGN',
        wfTypeCode: 'outsource_return_sign',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '10120502',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1059: {
    wfmCode: '1059',
    wfmName: '委外申请单', // 委外申请单
    billXkNoField: 'oapoXkNo',
    linkPrefix: '/purchase/outsource/material-apply/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.AUDIT',
        wfTypeCode: 'outsource_apply_audit',
        neededApplyCheckFlag: 1,
        showAutoCheckFlag: true, // 是否显示自动送审（前端维护）
        showAutoPublishFlag: true,
        resetAuthCode: '10120302',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1060: {
    wfmCode: '1060',
    wfmName: 'BASE.APPEAL_VENDOR', // 供应商申诉
    billXkNoField: 'appealXkNo',
    linkPrefix: '/purchase/supplier/complaint/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.INTER_AUDIT',
        wfTypeCode: 'vendor_appeal_inner_audit',
        neededApplyCheckFlag: 1,
        resetAuthCode: '10052104',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  },
  1061: {
    wfmCode: '1061',
    wfmName: '绩效评估报告', // 绩效评估报告
    billXkNoField: 'arXkNo',
    linkPrefix: '/purchase/supplier/kpi/assessment/report/detail/',
    list: [
      { act: 'BUTTON.NEW' },
      {
        act: 'BUTTON.PUBLISH',
        wfTypeCode: 'assessment_score_report_publish',
        neededApplyCheckFlag: 1,
        showAutoPublishFlag: true,
        resetAuthCode: '10050203',
        wfXkNo: '',
        wfNodeList: []
      }
    ]
  }
};

// 工作流类型列表
export const WORKFLOW_ITEMS = [
  { id: 0, text: 'BASE.CLOSE' },
  { id: 1, text: 'WORKFLOW.APPROVED_ON_PLATFORM' },
  { id: 2, text: 'WORKFLOW.APPROVED_ON_OA' }
];

export const WORKFLOW_ITEMS2 = [
  { id: 0, text: 'BASE.CLOSE' },
  { id: 1, text: 'BASE.ACTIVATE' }
];

// 审批人类型列表
export const APPROVER_TYPES = [
  { id: 1, text: 'BASE.SUP_ROLE' },
  { id: 2, text: 'WORKFLOW.ROLE' },
  { id: 3, text: 'WORKFLOW.EMPLOYEE' },
  { id: 4, text: 'WORKFLOW.DOC_EMPLOYEE' },
  { id: 5, text: 'WORKFLOW.PREV_SELECT' }
];

// 审批人类型 1.上级岗位 2.指定岗位 3.指定员工 4.单据关联员工 5.上一关指定
export type ApproverType = 1 | 2 | 3 | 4 | 5;

// 会签设置
export const MULTI_CHECK_FLAGS = [
  { id: 0, text: 'WORKFLOW.ONE_OF' },
  { id: 1, text: 'WORKFLOW.COUNTERSIGN' }
];

// 审批状态 0.待送审 1.审批中 2.已审批
export const WORKFLOW_STATUS = [
  'WORKFLOW.UN_START_APPROVAL',
  'WORKFLOW.UNDER_APPROVAL',
  'WORKFLOW.APPROVED'
];

// 条件类型。如果后端增加了新类型，这里需要增加对应的配置项。
export const CONDITION_TYPES = [
  { id: '1', text: 'BASE.FACTORY_PROFIT_CENTER' }, // 工厂/利润中心
  {
    id: '2',
    text: 'WORKFLOW.TOTAL_AMOUNT',
    wfmCodes: ['1012', '1013', '1024', '1032']
  }, //单据总金额 [采购订单|付款单|付款申请|预付款]
  {
    id: '2',
    text: 'BID.QUOTE_TOTAL_AMT',
    wfmCodes: ['1004', '1007', '1023', '1027', '1029', '1045', '1046']
  }, // 报价总金额 [询价|招标|项目招标|竞价|多物料竞价|比价-询价|比价-招标]
  { id: '3', text: 'BASE.RESULT_DESC', wfmCodes: ['1008'] }, // 检验结果
  {
    id: '4',
    text: 'BASE.INQUIRY_TYPE',
    wfmCodes: ['1004', '1023', '1045', '1046']
  }, // 询价类别[询价|招标|比价-询价|比价-招标]
  {
    id: '5',
    text: 'BASE.SUPPLIER_CATEGORY',
    wfmCodes: ['1005', '1015', '1018', '1034', '1038', '1040']
  }, // 供应商分类 [潜在供应商|PCN通知|供应商准入|送货单|供应商登记|供应商资质]
  { id: '6', text: 'PR.PR_TYPE', wfmCodes: ['1022'] }, // 请购类型
  { id: '7', text: 'BASE.CONTRACT_TYPE', wfmCodes: ['1037'] }, // 合同类型
  { id: '8', text: 'BASE.NUCLEAR_PRICE_TYPE', wfmCodes: ['1014'] }, // 核价类型
  { id: '9', text: 'BASE.CERT_TYPE', wfmCodes: ['1040', '1041'] }, // 资质类型
  { id: '10', text: 'INQUIRY_TENDER.BIDDING_TYPE', wfmCodes: ['1007', '1029'] }, // 竞价类别 [竞价|多物料竞价]
  { id: '11', text: 'BASE.SAMPLE_TYPE_NAME', wfmCodes: ['1039'] }, // 样品类型 [索样通知]
  { id: '12', text: 'COMPANY_NOTIFY.NOTICE_TYPE', wfmCodes: ['1042'] }, // 通知类型 [供应商通知]
  {
    id: '13',
    text: 'WORKFLOW.CREATOR_ROLE',
    wfmCodes: ['1013', '1045', '1046', '1026', '1054']
  }, // 制单人岗位 [采购订单|比价单|询价需求单|入库单]
  {
    id: '14',
    text: 'BASE.CUSTOM_FIELD',
    wfmCodes: ['1007', '1013', '1014', '1022', '1029', '1031', '1034']
  }, // 自定义字段-预设值类型 [竞价|采购单|核价单|请购单|多物料竞价|延迟送货申请|送货单], 启用时需要同时在配置中增加 billType 字段,
  { id: '15', text: 'BASE.PURCHASE_ORG', wfmCodes: ['1027'] }, // 采购组织 [项目招标]
  { id: '16', text: 'BASE.PURCHASE_TYPE', wfmCodes: ['1001', '1013'] }, // 采购类型 [对账单|采购订单]
  { id: '17', text: 'WORKFLOW.SUBMITTER_ROLE', wfmCodes: ['1008'] }, // 送审人岗位 [来料检验]
  { id: '18', text: 'DELIVERY.RECEIVE_STORE', wfmCodes: ['1034'] }, // 收货仓库 [送货单]
  { id: '19', text: 'BASE.DOCUMENT_CLASS', wfmCodes: ['1013'] }, // 单别[采购单]
  { id: '20', text: 'CUSTOMS.MATERIAL_TYPE', wfmCodes: ['1052'] }, // 物料类型[关务资料管理]
  {
    id: '21',
    text: 'INQUIRY.TOTAL_AMOUNT_SELECTED',
    wfmCodes: ['1045', '1046', '1029']
  }, // 入选总金额[询价比价单|招标比价单|多物料竞价]
  { id: '22', text: 'BASE.SAMPLE_TYPE_NAME', wfmCodes: ['1055'] }, // 样品类型[样品管理]
  { id: '23', text: 'BASE.TENDER_CATEGORY', wfmCodes: ['1027'] }, // 招标类别[项目招标]
  { id: '24', text: 'BASE.APPEAL_TYPE', wfmCodes: ['1060'] } // 申诉类型[供应商申诉]
];
